module.exports = __webpack_public_path__ + "static/img/2.a2c1920.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v14_new_features/2.png
// module id = 9sNu
// module chunks = 0